<template>
	<div class="popup show-popup">
		<div class="popup-content">
			<h4>Aktivacija dostopa je uspešno končana.</h4>
			<p class="bottom"><a href="#" class="button green" v-on:click.prevent="close">Naprej</a></p>
		</div>
	</div>
</template>

<script>
	import popup from '../popup.js'

	export default {
		mixins: [popup],
		methods: {
			close() {
				if (this.data) {
					window.location.href = this.data;
				} 
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PopupActivationSuccess.vue